import { EventLocationTypeEnum } from 'modules/calendar/events/constants'
import { EventLocationInterface } from 'modules/calendar/events/types/event-interface'

export function hasMeetingLink(locationType?: EventLocationTypeEnum) {
  return (
    !!locationType &&
    [
      EventLocationTypeEnum.ExternalLink,
      EventLocationTypeEnum.Zoom,
      EventLocationTypeEnum.GoogleMeet,
    ].includes(locationType)
  )
}

export const filterLocationBasedOnTempState = (locations: EventLocationInterface[]) => {
  return locations.filter(
    location =>
      ![
        EventLocationTypeEnum.ExternalLink,
        EventLocationTypeEnum.Zoom,
        EventLocationTypeEnum.GoogleMeet,
      ].includes(location.locationType),
  )
}
